module.exports = __webpack_public_path__ + "static/media/post-series.cd23caae.svg";